// extracted by mini-css-extract-plugin
module.exports = {"title":"styles-m__title___rvxFV","description":"styles-m__description___faHPv","signInButton":"styles-m__signInButton___rA1m9"};